import React from 'react'
import { get } from 'lodash'
import { gql, useQuery } from '@apollo/client'
import { Link } from 'react-router-dom'

import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ErrorOutlineIcon from 'components/material-symbol/icons/ErrorOutline'
import LibraryBooksIcon from 'components/material-symbol/icons/LibraryBooks'

import ActionTile from 'components/action-tile'
import BookingTypesView from '../booking-types/booking-types-view'
import GroupEventsPanel from '../events/group-events-panel'
import { useStyles } from './styles'
import { OFFERINGS_TAB } from './routes'

const GET_AVAILABILITY = gql`
  query CoachAvailability {
    coachAvailabilities {
      coachFacility {
        id
        name
      }
      startDate
      timeZone
      timeSlots {
        day
        startTime
        endTime
      }
    }
  }
`

const OfferingsPage = ({
  selectedTab,
  hasCoachProfile,
  setShouldShowBookingTypeDisclaimer,
  groupEventsPanel,
}) => {
  const { data, loading } = useQuery(GET_AVAILABILITY)
  const classes = useStyles()
  const availabilities = get(data, 'coachAvailabilities', [])
  const showSetAvailabilityTooltip =
    !loading && !availabilities?.some(a => a.timeSlots.length > 0)

  return (
    <Container className={classes.root}>
      {showSetAvailabilityTooltip ? (
        <Box className={classes.availabilityWarningBox}>
          <Box display="flex" alignItems="center">
            <ErrorOutlineIcon color="primary" style={{ marginRight: '10px' }} />
            <Typography
              variant="body1"
              className={classes.availabilityWarningText}
            >
              Looks like you haven't set your availability at each of your
              locations yet. We recommend doing that first before creating your
              coach offerings.
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row-reverse">
            <Button
              variant="outlined"
              color="primary"
              component={Link}
              to="/pga-coach/settings/availability"
            >
              Set Availability
            </Button>
          </Box>
        </Box>
      ) : null}
      {selectedTab === OFFERINGS_TAB.BOOKING_TYPE ? (
        <Box className={classes.tabContent}>
          {hasCoachProfile ? (
            <Grid container>
              <BookingTypesView
                setShouldShowDisclaimer={setShouldShowBookingTypeDisclaimer}
              />
            </Grid>
          ) : (
            <ActionTile
              className={classes.disabledActionTile}
              icon={LibraryBooksIcon}
              headlineText="Booking Type"
              captionText="Before publishing your booking type, please make sure you have **first created your Coach Profile**."
              callToAction={
                <Button
                  component={Link}
                  to="/pga-coach/profile"
                  variant="contained"
                  color="primary"
                  data-cy="see-coach-booking-types"
                >
                  Go To Coach Profile
                </Button>
              }
            />
          )}
        </Box>
      ) : (
        <Box className={`${classes.groupEventsWrapper} ${classes.tabContent}`}>
          <GroupEventsPanel panel={groupEventsPanel} showInlineTabs />
        </Box>
      )}
    </Container>
  )
}

export { OFFERINGS_TAB, getOfferingsPath, parseOfferingsTab } from './routes'
export default OfferingsPage
